import driversActionCreators, { actionTypes } from './driversActions';

export default driversActionCreators;
export { actionTypes };
